import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { IconAdd } from '../../../../assets/icons/icon-add';
import { Header, Page, PopUpNav, Tabs } from '../../../../components';
import { IconDeviceList, IconEye, IconGridView, IconListView } from '../../../../assets/popup-nav-icons';
import { Tip } from '../../../../components/tip';
import { LearningScenarios } from '../../../../data-access/gql-types/graphql';
import { ROUTES } from '../../../../routes/routes';
import ExalusChannels from '../../components/channels';
import StateSyncButton from '../../components/state-sync-button';
import { useExalusStorageContext } from '../../context/storage';
import { useExalusChannelStateListChanged } from '../../hooks/channels';
import { useLoggedUser } from '../../hooks/common/logged-user';
import { useChannels } from './hooks/use-channels';

const ChannelList: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation('channel-list');
  const { t: td } = useTranslation('device-list');
  const { t: tdash } = useTranslation('dashboard');
  const { groupedChannels, isFetched, isLoading, tabs } = useChannels();
  const { activeChannelTabIndex, setActiveChannelTab, isChannelsListView, toggleChannelsListView } =
    useExalusStorageContext();
  const { canAddRemoveConfigureDevice, canDeviceEdit } = useLoggedUser();
  useExalusChannelStateListChanged();

  return (
    <Page
      isStickyHeader
      containerClassName="page__container--flex-height"
      carouselContent
      header={
        <>
          <Header title={t('channels')} installationLogoTitleHeight>
            <StateSyncButton />
            {canAddRemoveConfigureDevice && (
              <button onClick={() => navigate(ROUTES.AddExalusDevices())}>
                <IconAdd />
              </button>
            )}

            <PopUpNav
              links={[
                ...(canDeviceEdit
                  ? [
                      {
                        onClick: () => navigate(ROUTES.Device()),
                        label: t('devicesList'),
                        icon: <IconDeviceList />,
                      },
                      {
                        onClick: () => navigate(ROUTES.ChannelsVisibility()),
                        label: t('editVisibility'),
                        hasLineBelow: true,
                        icon: <IconEye />,
                      },
                    ]
                  : []),
                {
                  onClick: toggleChannelsListView,
                  label: isChannelsListView ? tdash('gridView') : tdash('listView'),
                  icon: isChannelsListView ? <IconGridView /> : <IconListView />,
                },
              ]}
            />
          </Header>
          <Tabs
            tabList={tabs}
            activeTabIndex={activeChannelTabIndex}
            setActiveTabIndex={setActiveChannelTab}
            tabsType="pills"
            isDivider={false}
            moreButton="normal"
          />
        </>
      }
    >
      <ExalusChannels itemGroupsList={groupedChannels} isFetched={isFetched} isLoading={isLoading} />
      <Tip tip={td('DeviceAddTip')} learningKey={LearningScenarios.AddDevice} point={<IconAdd />} top={40} right={68} />
    </Page>
  );
};

export default ChannelList;
